import type { Form } from '@jmvdevelop/svelte-form';
import { delay } from '$lib/utils/delay';
import { fail, ok, type Result } from '$lib/utils/result.js';
import { temporizePromise } from '$lib/utils/temporizePromise.js';
import type { lazy } from '$lib/utils/types';
import { LoginMutationDocument } from '$gql/graphql.js';
import { getContainer } from '$components/Context/ContainerContext';
import type { LoginFormData } from '$components/LoginForm/LoginFormData.js';

type OnSubmit = (form: Form<LoginFormData, string>) => Promise<Result<unknown, string>>;

export const createOnSubmit: (options: {
    targetPath: lazy<string | null>;
}) => OnSubmit = (options) => {
    const { apollo, svelteClient } = getContainer();
    const { goto } = svelteClient;

    return (form) => {
        return temporizePromise(
            500,
            (async () => {
                const { email, password } = form.getState().values;
                try {
                    const result = await apollo().mutate({
                        mutation: LoginMutationDocument,
                        variables: { email, password },
                    });
                    const error = result.data?.login.error;
                    const user = result.data?.login.user;
                    if (error != null) {
                        return fail(error);
                    }
                    if (user != null) {
                        const targetPath = options.targetPath();
                        if (targetPath !== null) {
                            await goto?.(targetPath, {
                                invalidateAll: true,
                            });
                        } else {
                            window.location.reload();
                            await delay(10000);
                        }

                        return ok(true);
                    }
                    return fail('Erreur inconnue.');
                } catch {
                    return fail('Erreur inconnue.');
                }
            })(),
        );
    };
};
